// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__r2GRo","inner":"Footer_inner__2g21X","nextIcon":"Footer_nextIcon__3dLa0","innerLeft":"Footer_innerLeft__ahnpr"};